module.exports = __webpack_public_path__ + "img/logomarca_branca_ufrj_sgtic_transparente.4b67e1b8.png";